export const storeSelectedText = 'DECISION_STORE_SELECTED_TEXT';
export const storeTextSelection = 'DECISION_STORE_TEXT_SELECTION';
export const storeSelectionId = 'DECISION_STORE_SELECTION_ID';

export const openHighlightPopover = 'DECISION_OPEN_HIGHLIGHT_POPOVER';
export const closeHighlightPopover = 'DECISION_CLOSE_HIGHLIGHT_POPOVER';
export const showMoreLikeThisMenu = 'DECISION_SHOW_MORE_LIKE_THIS_MENU';
export const storeMoreLikeThisMenuText =
  'DECISION_STORE_MORE_LIKE_THIS_MENU_TEXT';

export const openMoreLikeThisModal = 'DECISION_OPEN_MORE_LIKE_THIS_MODAL';
export const closeMoreLikeThisModal = 'DECISION_CLOSE_MORE_LIKE_THIS_MODAL';

export const fetchingMoreLikeThisDecisions = 'DECISION_FETCHING_MORE_LIKE_THIS';
export const storeMoreLikeThisDecisions =
  'DECISION_STORE_MORE_LIKE_THIS_DECISIONS';
export const storeSelectionTooLongError =
  'DECISION_STORE_SELECTION_TOO_LONG_ERROR';
export const fetchEndMoreLikeThisDecisions =
  'DECISION_FETCH_END_MORE_LIKE_THIS';

export const errorServer = 'DECISION_MORE_LIKE_THIS_ERROR_SERVER';

export const openActionSidebarPopover = 'DECISION_OPEN_ACTION_SIDEBAR_POPOVER';
export const closeActionSidebarPopover =
  'DECISION_CLOSE_ACTION_SIDEBAR_POPOVER';
export const switchActionSidebarRemove =
  'DECISION_SWITCH_ACTION_SIDEBAR_REMOVE';

export const openActionSidebarRemovePopover =
  'DECISION_OPEN_ACTION_SIDEBAR_REMOVE_POPOVER';
export const closeActionSidebarRemovePopover =
  'DECISION_CLOSE_ACTION_SIDEBAR_REMOVE_POPOVER';

export const openActionSidebarSummaryPopover =
  'DECISION_OPEN_ACTION_SIDEBAR_SUMMARY_POPOVER';
export const closeActionSidebarSummaryPopover =
  'DECISION_CLOSE_ACTION_SIDEBAR_SUMMARY_POPOVER';
